import { render, staticRenderFns } from "./courseCollection.vue?vue&type=template&id=db229130&scoped=true&"
import script from "./courseCollection.vue?vue&type=script&lang=js&"
export * from "./courseCollection.vue?vue&type=script&lang=js&"
import style0 from "./courseCollection.vue?vue&type=style&index=0&id=db229130&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db229130",
  null
  
)

export default component.exports